import { useIntl } from 'react-intl'
import { TRANSLATIONS } from './translations'

/** @public */
export function useLanguages() {
	const intl = useIntl()
	return { languages: TRANSLATIONS, currentLanguage: intl.locale }
}
